import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

export const schemaUK = yup.object().shape({
  amount: yup
    .string()
    .required('Loan amount required')
    .test('minCurrencyAmount', 'Between £1,000 and £1,000,000', (value) => {
      const numericValue = currencyToNumber(value, {
        currencySymbol: true,
        locale: 'en-GB',
        minorUnits: false,
      });
      if (!numericValue) return false;
      return numericValue >= 1000 && numericValue <= 1000000;
    }),
});
